import { Component, inject } from '@angular/core';
import {HeaderComponent} from "../../common/header/header.component";
import {LocaleService} from "../../../locale/locale.service";
import {CardComponent} from "../../common/card/card.component";
import {ActionListItemComponent} from "../../common/action-list-item/action-list-item.component";
import {FooterComponent} from "../../common/footer/footer.component";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-welcome',
  imports: [
    HeaderComponent,
    CardComponent,
    ActionListItemComponent,
    FooterComponent,
    RouterLink
  ],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.css'
})
export class WelcomeComponent {
  locale = inject(LocaleService);
}
